module.exports = __webpack_public_path__ + "img/ic_invite_download_google.4ff575c.svg";